/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Property_Ai_Generate_Description_HintInputs */

const cs_property_ai_generate_description_hint = /** @type {(inputs: Property_Ai_Generate_Description_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vytvoří ${i?.locale} popis z faktů o nemovitosti. Neuložené úpravy se před spuštěním automaticky uloží.`)
};

const en_property_ai_generate_description_hint = /** @type {(inputs: Property_Ai_Generate_Description_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafts the ${i?.locale} description from property facts. Unsaved edits are flushed before the job starts.`)
};

/**
* | output |
* | --- |
* | "Drafts the {locale} description from property facts. Unsaved edits are flushed before the job starts." |
*
* @param {Property_Ai_Generate_Description_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_generate_description_hint = /** @type {((inputs: Property_Ai_Generate_Description_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Generate_Description_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_generate_description_hint(inputs)
	return cs_property_ai_generate_description_hint(inputs)
});